// A soma considera o subtotal em centavos de cada linha, igual à composição.
export function totalItensVenda(itens: { quantidade?: number | string; valor_unitario?: number | string }[]): number {
  const centavos = itens.reduce((s, it) => {
    const q = Number(it.quantidade ?? 0);
    const v = Number(it.valor_unitario ?? 0);
    const subtotal = q * v;
    return s + (Number.isFinite(subtotal)
      ? Math.sign(subtotal) * Math.round((Math.abs(subtotal) + Number.EPSILON * Math.max(1, Math.abs(subtotal))) * 100) : 0);
  }, 0);
  return centavos / 100;
}
